import * as CSS from "csstype";
import { ThemeLetterSpacings } from "styled-system";
import { ThemeLineHeights } from "styled-system";
import { ThemeFontWeights } from "styled-system";
import { ObjectOrArray, ThemeFontFamilies, ThemeFontSizes } from "styled-system";

export const fontsMap: ThemeFontFamilies = {
	//   heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
	//   body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
	//   mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
};
export const fonts: ObjectOrArray<CSS.Property.FontFamily, keyof ThemeFontFamilies> = [];


export const fontSizesMap: ThemeFontSizes = {
	smaller: 10,
	small: 12,
	regular: 14,
	medium: 16,
	large: 28,
	huge: 20
};

// export const fontSizes: ObjectOrArray<CSS.Property.FontSize<number>, keyof ThemeFontSizes> = [];

export const fontWeightsMap: ThemeFontWeights = {
	hairline: 100,
	thin: 200,
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 600,
	bold: 700,
	extrabold: 800,
	black: 900,
};

// export const fontWeights: ObjectOrArray<CSS.Property.FontSize<number>, keyof ThemeFontWeights> = [];

export const lineHeightsMap: ThemeLineHeights = {
	normal: 'normal',
	none: 1,
	shorter: 1.25,
	short: 1.375,
	base: 1.5,
	tall: 1.625,
	taller: 2,
	'3': 3,
	'4': 4,
	'5': 5,
	'6': 6,
	'7': 7,
	'8': 8,
	'9': 9,
	'10': 10,
};

export const lineHeights: ObjectOrArray<CSS.Property.LineHeight, keyof ThemeFontWeights> = [];

export const letterSpacingsMap: ThemeLetterSpacings = {
	tighter: -0.025,
	tight: -0.025,
	normal: 0,
	wide: 0.025,
	wider: 0.05,
	widest: 0.1
};

// export const letterSpacings: ObjectOrArray<CSS.Property.LineHeight, keyof ThemeFontWeights> = [];
